// Two-step quote form: shows one [data-quote-step] at a time, validates a step before moving on, and toggles the store URL when the visitor has no store yet.
// Without JavaScript every step stays visible, so the form still submits as one page.
class QuoteSteps extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.steps = [...this.querySelectorAll('[data-quote-step]')];
    this.progress = this.querySelector('[data-quote-progress]');
    this.index = Number(this.dataset.startStep) || 0;
    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.next();
      else if (event.command === '--back') this.show(this.index - 1, true);
    }, { signal });

    const noStore = this.querySelector('[data-no-store]');
    const storeUrl = this.querySelector('[data-store-url]');
    if (noStore && storeUrl) {
      const sync = () => {
        storeUrl.required = !noStore.checked;
        storeUrl.disabled = noStore.checked;
        if (noStore.checked) storeUrl.value = '';
      };
      noStore.addEventListener('change', sync, { signal });
      sync();
    }
    this.show(this.index, false);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  next() {
    const fields = this.steps[this.index].querySelectorAll('input, select, textarea');
    for (const field of fields) {
      if (!field.disabled && !field.checkValidity()) {
        field.reportValidity();
        return;
      }
    }
    this.show(this.index + 1, true);
  }

  show(target, moveFocus) {
    this.index = Math.max(0, Math.min(target, this.steps.length - 1));
    this.steps.forEach((step, i) => { step.hidden = i !== this.index; });
    if (this.progress) this.progress.textContent = `${this.index + 1}/${this.steps.length}`;
    if (moveFocus) this.steps[this.index].querySelector('input, select, textarea')?.focus();
  }
}

if (!customElements.get('s-quote-steps')) customElements.define('s-quote-steps', QuoteSteps);
